export function getErrorsFields(requiredFields, dataFields) {
    let dataAux = dataFields ? dataFields : {};
    let errors = [];
    requiredFields.forEach((field) => {
        errors[field] = dataAux[field] ? dataAux[field] !== '' : false;
    });
    return errors;
}

export function isValidData(requiredFields, dataFields) {
    let errorsAux = getErrorsFields(requiredFields, dataFields);
    let completeData = true;

    for (let key in errorsAux) {
        if (!errorsAux[key]) {
            completeData = false;
        }
    }
    return completeData;
}